import React from 'react';
import CopyToClip from '../../infra/CopyToClip';
import './LandLine.css';

const LandLine = ({title, value}) => {
  return (
    <div className='landLine'>      
      <div className='landLineTitle'>
        <div>{title}:</div>
        <div><CopyToClip text={value}/></div>
      </div>
      <div className='landLineValue'>{value}</div>
    </div>
  );
};

export default LandLine;